import { ExternalCell, ExternalRow, ExternalLink } from '@cast/design-system';

import { DetailsRowContainer, DetailWitTitle } from './DetailsRowContainer';
import { FailedHelmTestEvent } from '../../../types';

import { getDocsLink } from '@cast/utils';

export const FailedHelmTestEventSubRow = (event: FailedHelmTestEvent) => {
  return (
    <DetailsRowContainer event={event}>
      <ExternalRow>
        <ExternalCell sx={{ width: '100% !important' }}>
          <DetailWitTitle
            title="Message:"
            detail={
              <>
                Test of castai-workload-autoscaler has failed. Please go
                to&nbsp;
                <ExternalLink
                  link={getDocsLink(
                    'docs_workload_autoscaler_failed_helm_test'
                  )}
                >
                  https://docs.cast.ai/docs/workload-autoscaling-overview#failed-helm-test-hooks
                </ExternalLink>
                &nbsp;to investigate.
              </>
            }
            testId="message"
            titleVariant="light"
          />
        </ExternalCell>
      </ExternalRow>
    </DetailsRowContainer>
  );
};
